import * as GameCommands from "../../core/src/commands/GameCommands";
import { DefaultLayers } from "../../core/src/utils/Layers";
import ViewManager from "../../core/src/utils/ViewManager";
import { UIButtons } from "../../core/src/ui/UIButtons";
import SwitchButton from "../../core/src/views/components/SwitchButton";
import UIController from "../../core/src/ui/UIController";
import SoundController from "../../core/src/utils/SoundController";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import BangUp from "../../core/src/utils/BangUp";
import { Ease } from "../../core/src/Ease";
import GameModel from "../../core/src/model/GameModel";
import BetModel from "../../core/src/model/BetModel";
import JackpotsModel from "../model/JackpotsModel";
import VendorWrapper from "../controllers/VendorWrapper";
import IJackpotData from "../server/data/IJackpotData";
import SoundVars from "../../core/src/const/SoundVars";
import HTMLPopupsManager from "../../core/src/utils/HTMLPopupsManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import CommandManager from "../../core/src/commands/CommandManager";
import ErrorModel from "../../core/src/model/ErrorModel";
import ErrorPopup from "../../core/src/ui/popups/ErrorPopup";


export function SetBetCommand(betData:{ coinIndex: number, multiplier: number, value: number }) {
    BetModel.setStake(betData.multiplier, betData.coinIndex);
    GameCommands.UpdateBetCommand();
  }

export function ToggleBetPopupCommand() {
    GameCommands.ToggleBetPopupCommand();
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Bet) as SwitchButton;
    btn.toggle();
}

export function ToggleAutoplayPopupCommand() {
    GameCommands.ToggleAutoplayPopupCommand();
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.AutoPlay) as SwitchButton;
    btn.toggle();
}

export function ToggleTuboSpinCommand() {
    GameCommands.ToggleTuboSpinCommand();
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get("turbo") as SwitchButton;
    btn.toggle();
    SoundController.playSound(SoundVars.BUTTON_CLICK);
}

export function ToggleSoundPopupCommand() {
    UIController.toggleComponent("soundPopup");
    let btn1 = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn1.toggle();
    let btn2 = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.SoundMuted) as SwitchButton;
    btn2.toggle();
}
export function ToggleSoundButtonCommand() {
    let btn1 = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn1.visible = SoundController.isSoundEnabled;
    let btn2 = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.SoundMuted) as SwitchButton;
    btn2.visible = !SoundController.isSoundEnabled;
}

export const ToggleMasterSoundBtn = (enabled?: boolean) => {
    SoundController.toggleMasterSound(enabled);
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn.switch(!SoundController.isSoundEnabled);
};

export const ToggleSoundFXCommand = (enabled?: boolean) => {
    SoundController.toggleEffects(enabled);
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn.switch(!SoundController.isSoundEnabled);
    ToggleSoundButtonCommand();
};

export const ToggleMusicCommand = (enabled?: boolean) => {
    SoundController.toggleMusic(enabled);
    let btn = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get(UIButtons.Sound) as SwitchButton;
    btn.switch(!SoundController.isSoundEnabled);
    ToggleSoundButtonCommand();
};

export function UpdateJackpotsCommand() {
    if (GameModel.gameConfig.hasJackpotsFeature && JackpotsModel.jackpotsAvailable) {
        CommManager.send(
            RequestRegister.get("jackpotsUpdate"),
            async function (data: any) {
                VendorWrapper.setJackpotValues(data.data as IJackpotData[]);
            },
            this
        );
    }
}
export function ToggleJackpotBtnCommand(state: boolean) {
    let btn: SwitchButton = ViewManager.getLayer(DefaultLayers.BetBar)
        .getCurrentScene()
        .buttons.get("jackpot") as SwitchButton;
    btn && btn.switch(state);
}

export function ShowInsufficientFoundsDialog(callback) {
    UIController.toggleComponent("insufficientFundsPopup", callback);
}

export function GoHome() {
    if (GameModel.homeUrl) {
        if (GameModel.homeUrl === "close") {
            window.close();
        } else {
            document.location.assign(GameModel.homeUrl);
        }
    } else {
        window.history.back();
    }
}

export function showHistory() {
    CommManager.send(
        RequestRegister.get("getLastPlayHistory"),
        (data) => {
            HTMLPopupsManager.showPopup("history", data);
            CommandManager.execute(Commands.CLOSE_SETTINGS);
        },
        this,
        (err) => {
            ErrorModel.errorCode = err.data.error;
            CommandManager.execute(Commands.CLOSE_SETTINGS);
            new ErrorPopup().show();
        }
    );

}